// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toolbar":"toolbar","info":"info","duration":"duration","generic":"generic","md-button":"md-button"};